module.exports = __webpack_public_path__ + "img/main_text.99341092.png";